import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../actions/e-loketLayoutActions";

class NoAccessPage extends React.Component {
    componentDidMount() {
        this.props.loadLayout('');
    }

    render() {
        return (
            <section className="o-page__main u-clear" role="main">
                <div className="c-section-wrap">
                    <div className="c-section c-section--pink">
                        <header className="c-section__header">
                            <h2 className="title">Geen Toegang</h2>
                        </header>
                        <div className="c-section__body" style={{ textAlign: 'center' }}>
                            <div className="c-content-block">
                                <span className="error">
                                    Je hebt geen toegang.<br />
                                    Mogelijk ben je nog ingelogd met je "Mijn SportVlaanderen" account.<br />
                                    Log hier eerst uit en klik dan opnieuw op de link naar het online platform.
                                    </span><br /><br />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

NoAccessPage.propTypes = {
    loadLayout: PropTypes.func.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadNoAccessPageLayout, dispatch)
    };
}
export default connect(null, mapDispatchToProps)(NoAccessPage);
